import qs from '@src/utils/query-string-util';

/**
 * 格式化路由
 * @example
 * formatRoute('/detail', {name: 'allen'})
 *
 * @param {string} routePath - 路由路径, 如: /detail
 * @param {object} [queryParams] - query string 参数, 如: {name: 'allen'}
 * @returns {string}
 */
export default function formatRoute(routePath, queryParams) {
  return routePath + (queryParams ? '?' + qs.stringify(queryParams) : '');
}
